type Props = {
  className?: string
}

export function PrivacyArchitectureMark({ className = '' }: Props) {
  return (
    <svg className={`privacy-architecture-mark ${className}`.trim()} viewBox="0 0 96 96" aria-hidden="true" focusable="false">
      <ellipse className="privacy-architecture-mark__orbit" cx="48" cy="48" rx="41" ry="20" transform="rotate(-17 48 48)" />
      <circle className="privacy-architecture-mark__dot" cx="8" cy="56" r="4" />
      <circle className="privacy-architecture-mark__dot" cx="88" cy="40" r="4" />
      <rect className="privacy-architecture-mark__device" x="35" y="16" width="26" height="64" rx="8" />
      <circle className="privacy-architecture-mark__core" cx="48" cy="46" r="8" />
    </svg>
  )
}
